import React from 'react'
import Helmet from 'react-helmet'

const PageSEO = ({
  ogTitle,
  ogDescription,
  ogImage
}) => {
  return (
    <Helmet
      title = {ogTitle}
      meta={[
        {property: 'og:type', content: 'website'},
        {property: 'og:title', content: ogTitle},
        {property: 'og:description', content: ogDescription},
        {property: 'og:image', content: ogImage},
        {property: 'og:image:type', content: 'image/jpeg'},
        {property: 'og:image:width', content: '1920'},
        {property: 'og:image:height', content: '1280'}
      ]}
    />
  );
};

export default PageSEO;


// WEBPACK FOOTER //
// ./src/app/components/molecules/PageSEO/PageSEO.js